import { proxy } from 'valtio'

export interface MemberUpgradeDialogState {
  open: boolean
  message: string
}

export const memberUpgradeDialogStore = proxy<MemberUpgradeDialogState>({
  open: false,
  message: '',
})

export function openMemberUpgradeDialog(payload?: {
  message?: string
}) {
  memberUpgradeDialogStore.open = true
  memberUpgradeDialogStore.message = payload?.message?.trim() ?? ''
}

export function closeMemberUpgradeDialog() {
  memberUpgradeDialogStore.open = false
}
